import React, { useState } from "react";
import example from "@/content/exampleReading.json";

export const ExampleReading = () => {
  const [open, setOpen] = useState(false);
  const paragraphs = example.interpretation.split("\n\n");
  const shown = open ? paragraphs : paragraphs.slice(0, 2);
  return (
    <section className="mb-10 rounded-2xl border border-[#D9A441]/20 bg-[#131422]/60 p-6 sm:p-8" data-testid="example-reading" aria-labelledby="example-heading">
      <p className="text-xs uppercase tracking-[0.25em] text-[#E5C365]">Example reading</p>
      <h2 id="example-heading" className="mt-2 font-display text-2xl font-medium text-[#F8F3E6]">
        What a finished reading looks like
      </h2>
      <p className="mt-1 text-xs text-[#A3A5B8]">
        {example.deck} · {example.spread}. The question and cards were selected for this demonstration; the interpretation below was generated by The Cardlight itself, unedited.
      </p>
      <p className="mt-5 font-display text-lg italic text-[#E5C365]">“{example.question}”</p>
      <div className="mt-5 flex flex-wrap justify-center gap-4 sm:justify-start">
        {example.cards.map((c) => (
          <figure key={c.name} className="w-24 text-center sm:w-28">
            <img
              src={c.image}
              alt={`${c.name}${c.reversed ? " (reversed)" : ""} tarot card from the Whispering Path Tarot deck, drawn in the ${c.position} position`}
              loading="lazy"
              className="aspect-[2/3] w-full rounded-lg border border-[#D9A441]/40 object-cover"
              style={{ transform: c.reversed ? "rotate(180deg)" : "none" }}
            />
            <figcaption className="mt-2 text-[10px] uppercase tracking-[0.2em] text-[#A3A5B8]">{c.position}</figcaption>
            <p className="text-xs text-[#F8F3E6]">{c.name}{c.reversed ? " · reversed" : ""}</p>
          </figure>
        ))}
      </div>
      <div className="mt-6 space-y-3 text-sm leading-relaxed text-[#F8F3E6]/90" data-testid="example-reading-text">
        {shown.map((p) => <p key={p.slice(0, 24)}>{p}</p>)}
      </div>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="example-reading-toggle"
        className="mt-4 text-sm text-[#E5C365] underline underline-offset-4 hover:text-[#F8F3E6]"
      >
        {open ? "Show less" : "Read the full example"}
      </button>
    </section>
  );
};
